import React from 'react';
import authRoles from '../../../auth/authRoles';
import SubAdminDashboard from './SubAdminDashboard';
import ShowAllBirthdays from './ShowAllBirthdays';

const SubAdminDashboardConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/home',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SubAdminDashboard />
				</React.Suspense>
			),
		},
		{
			path: '/upcoming-birthdays',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ShowAllBirthdays />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default SubAdminDashboardConfig;
